<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">{{helper.trans(`antifraudalerts.description.${alert.rule}.default`, {count: data?.count})}}</span>
    </div>
    <div v-if="data?.trafficBlocked" class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ helper.trans('labels.traffic_blocked') }} {{ data?.deviceName ? helper.trans('labels.device_name', {name: data?.deviceName}) : ''}}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import PayInCanceledDealsCountCheckDataDTO from "@/models/AntiFraud/PayInCanceledDealsCountCheckDataDTO";
import CopyButton from "@/components/CopyButton.vue";

export default defineComponent({
  name: "PayInCanceledDealsCountCheckDescription",
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): PayInCanceledDealsCountCheckDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as PayInCanceledDealsCountCheckDataDTO
    })

    return {
      helper,
      numberFormatter,
      data
    }
  }
})
</script>
